import * as React from 'react';

import {CampaignIcon} from './svg/campaign-icon';
import {EnvelopeIcon} from './svg/envelope-icon';

type Props = {
    messageCount: number;
    size: number;
};

EmailSequenceIcon.prototype.defaultProps = {
    size: 15,
};

/**
 * @deprecated This is a legacy icon
 */
export function EmailSequenceIcon(props: Props) {
    const {size, messageCount} = props;

    return messageCount > 1 ? (
        <CampaignIcon size={size} wrapWithDiv={false} />
    ) : (
        <EnvelopeIcon size={size} wrapWithDiv={false} />
    );
}
